<template>
  <div>
    <Modal :title="title" v-model="modalShow" width="600px">
      <Spin fix v-if="dataGetting"></Spin>
      <Alert show-icon type="error" v-else-if="getDataError">获取数据失败</Alert>
      <div class="req-form" v-else>
        <Form ref="reqForm" :model="reqForm" style="padding-right: 10px" :rules="reqRule">
          <Alert type="error" v-show="errorMsgShow" show-icon>{{ errorMsg }}</Alert>
          <FormItem label="卷" prop="volumeId">
            <Select v-model="reqForm.volumeId" transfer placeholder="请选择要分离的卷">
              <Option v-for="item in volumeList" :key="item.id" :value="item.id">{{ item.device }} ({{ item.id }})</Option>
            </Select>
          </FormItem>
        </Form>
      </div>
      <div slot="footer">
        <Button type="primary" @click="submit" :loading="submitting">提交</Button>
        <Button @click="modalShow = false" style="margin-left: 8px">取消</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import { deleteVolumeAttachmentPrivateCloudServer,
  getVolumeAttachmentPrivateCloudServerList } from '@/api/private-cloud/server'
export default {
  name: 'server-detach-volume',
  data () {
    return {
      title: '分离卷',
      serverId: null,
      dataGetting: false,
      getDataError: false,
      modalShow: false,
      submitting: false,
      volumeList: [],
      reqForm: {
        volumeId: ''
      },
      reqRule: {
        volumeId: [
          { required: true, message: '请选择要连接的卷', trigger: 'change' }
        ]
      },
      errorMsg: '',
      errorMsgShow: false
    }
  },
  methods: {
    openModal (id) {
      this.getVolumeList(id)
      this.reqForm.volumeId = ''
      this.serverId = id
    },
    // 获取卷列表
    getVolumeList (id) {
      this.dataGetting = true
      this.getDataError = false
      this.modalShow = true
      getVolumeAttachmentPrivateCloudServerList(id).then(res => {
        this.volumeList = res.data.volumeAttachments
        this.dataGetting = false
      }).catch(res => {
        this.dataGetting = false
        this.getDataError = true
        console.log(res.response)
      })
    },
    submit () {
      this.$refs['reqForm'].validate((valid) => {
        if (valid) {
          let reqData = {
            volume_id: this.reqForm.volumeId
          }
          this.submitting = true
          deleteVolumeAttachmentPrivateCloudServer(reqData, this.serverId).then(res => {
            this.modalShow = false
            this.$Notice.success({
              title: '操作成功！'
            })
            this.submitting = false
            this.$emit('callback')
          }).catch(res => {
            this.submitting = false
            if (res.request) {
              this.errorMsg = res.request.responseText
              this.$Notice.error({
                title: '操作失败！',
                desc: res.request.responseText
              })
            } else {
              this.errorMsg = '操作失败！'
              this.$Notice.error({
                title: '操作失败！'
              })
            }
            this.errorMsgShow = true
          })
        } else {
          this.$Notice.warning({
            title: '提交失败，请检查表单！'
          })
        }
      })
    }
  }
}
</script>

<style scoped>
  .req-form {
    max-height: 650px;
    overflow-y: auto;
  }
  .req-form::-webkit-scrollbar {
    width: 5px;
  }
  .req-form::-webkit-scrollbar-track {
    border-radius: 5px;
    background-color: #eee;
  }
  .req-form::-webkit-scrollbar-thumb {
    border-radius: 5px;
    background: #dbdbdb;
  }
</style>
